<template>
  <!-- Contact details -->
  <div class="w-full">
    <div class="max-w-xl">
      <!-- Contact Information Cards -->
      <div class="space-y-6">
        <div
          v-for="contact in contacts"
          :key="contact.id"
          class="group rounded-2xl bg-card-gradient p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-soft-lg dark:bg-card-gradient-dark"
        >
          <div class="flex items-start space-x-4">
            <div class="flex-shrink-0">
              <div class="flex size-12 items-center justify-center rounded-full bg-gradient-to-r from-accent/10 to-gradient-end/10 transition-all duration-300 group-hover:from-accent/20 group-hover:to-gradient-end/20 dark:from-accent/20 dark:to-gradient-end/20 dark:group-hover:from-accent/30 dark:group-hover:to-gradient-end/30">
                <component
                  :is="contact.icon"
                  class="size-6 text-accent dark:text-accent"
                />
              </div>
            </div>
            <div class="min-w-0 flex-1">
              <h3 class="mb-1 text-lg font-semibold text-ternary-dark dark:text-ternary-light">
                {{ contact.title }}
              </h3>
              <a
                :href="contact.href"
                class="text-gray-600 transition-colors duration-300 hover:text-accent dark:text-gray-400 dark:hover:text-accent"
                :class="contact.clickable ? 'cursor-pointer hover:underline' : 'cursor-default'"
                :aria-label="contact.ariaLabel"
              >
                {{ contact.name }}
              </a>
              <p v-if="contact.description" class="mt-1 text-sm text-gray-500 dark:text-gray-500">
                {{ contact.description }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional Information -->
      <div class="mt-12 rounded-2xl bg-gradient-to-br from-accent/5 to-gradient-end/5 p-6 dark:from-accent/10 dark:to-gradient-end/10">
        <h3 class="mb-4 text-xl font-semibold text-ternary-dark dark:text-ternary-light">
          What to Expect
        </h3>
        <ul class="space-y-3 text-gray-600 dark:text-gray-400">
          <li class="flex items-start space-x-3">
            <div class="mt-2 size-2 flex-shrink-0 rounded-full bg-accent" />
            <span>We'll respond to your inquiry within 24 hours</span>
          </li>
          <li class="flex items-start space-x-3">
            <div class="mt-2 size-2 flex-shrink-0 rounded-full bg-accent" />
            <span>Free initial consultation to discuss your project</span>
          </li>
          <li class="flex items-start space-x-3">
            <div class="mt-2 size-2 flex-shrink-0 rounded-full bg-accent" />
            <span>Detailed proposal with timeline and pricing</span>
          </li>
          <li class="flex items-start space-x-3">
            <div class="mt-2 size-2 flex-shrink-0 rounded-full bg-accent" />
            <span>Ongoing support throughout the development process</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Contact {
  id: string
  name: string
  title: string
  icon: any
  href: string
  clickable: boolean
  ariaLabel: string
  description?: string
}

interface Props {
  contacts: Contact[]
}

defineProps<Props>()
</script>
